import React, { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import banner from "../assets/images/banner.jpg";
import ReCAPTCHA from "react-google-recaptcha";
import { verifyRecaptcha } from "../api/verifyOtp"; // Adjust path as per project
import { submitDemoRequest } from "../api/submitDemoRequest";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
const Banner: React.FC = () => {
  const { t } = useTranslation();
  const [showForm, setShowForm] = useState(false);
  const [captchaToken, setCaptchaToken] = useState<string | null>(null);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const recaptchaRef = useRef<ReCAPTCHA | null>(null); // add ref to reset if needed
  const handleRequestDemo = (): void => {
    setShowForm(true);
  };

  const handleCloseForm = (): void => {
    setShowForm(false);
  };

  // Inside the Banner component

  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [errors, setErrors] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    requirement: "",
    selectedOptions: "",
  });
  const options = [
    "Esports",
    "Sports Draft",
    "Casual Games",
    "Tournament Management",
    "Other",
  ];
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    requirement: "",
  });
  const toggleOption = (option: string) => {
    if (selectedOptions.includes(option)) {
      setSelectedOptions(selectedOptions.filter((o) => o !== option));
    } else {
      setSelectedOptions([...selectedOptions, option]);
    }
  };
  const showSuccessToast = () => {
    toast.success(
      <div className="flex items-center gap-2">
        {/* <img
          src="https://cdn-icons-png.flaticon.com/512/5610/5610944.png"
          alt="Success"
          className="w-6 h-6"
        /> */}
        <span>Mail sent successfully!</span>
      </div>
    );
  };

  const showErrorToast = () => {
    toast.error(
      <div className="flex items-center gap-2">
        {/* <img
          src="https://cdn-icons-png.flaticon.com/512/463/463612.png"
          alt="Error"
          className="w-6 h-6"
        /> */}
        <span>Something went wrong. Please try again.</span>
      </div>
    );
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const newErrors = {
      name: formData.name.trim() === "" ? "Name is required" : "",
      email: formData.email.trim() === "" ? "Email is required" : "",
      phone: formData.phone.trim() === "" ? "Phone number is required" : "",
      company: formData.company.trim() === "" ? "Company name is required" : "",
      requirement: formData.requirement.trim() === "" ? "Requirement is required" : "",
      selectedOptions: selectedOptions.length === 0 ? "Please select at least one option" : "",
    };

    setErrors(newErrors);

    const hasError = Object.values(newErrors).some((error) => error !== "");
    if (hasError) return;

    // if (!captchaToken) {
    //   alert("Please complete the CAPTCHA.");
    //   return;
    // }

    setIsSubmitting(true);

    try {
      // const captchaResponse = await verifyRecaptcha(captchaToken);
      // if (!captchaResponse.success) {
      //   alert("Captcha verification failed. Please try again.");
      //   recaptchaRef.current?.reset(); // reset CAPTCHA on failure
      //   setCaptchaToken(null);
      //   return;
      // }

      // ✅ API Call to submit form
      await submitDemoRequest({
        ...formData,
        userEmail: formData.email, // 👈 user's email shown in email body
        // email: "drashti.vikani@gamerji.com,valay@gamerji.com,soham@gamerji.com,soham.thacker@gamerji.com", // 👈 recipients
        email: "valay@gamerji.com,soham@gamerji.com,soham.thacker@gamerji.com".split(","),

        selectedOptions,
      });
      showSuccessToast();
      // alert("Form submitted successfully!");
      setFormData({
        name: "",
        email: "",
        phone: "",
        company: "",
        requirement: "",
      });
      setSelectedOptions([]);
      setCaptchaToken(null);
      recaptchaRef.current?.reset();
      setShowForm(false);

    } catch (err) {
      console.error("Error submitting form:", err);
      // alert("Something went wrong. Please try again.");
      showErrorToast();
    } finally {
      setIsSubmitting(false);
    }
  };


  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  return (
    <div className="relative w-full h-[80vh]">
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
        draggable
        theme="dark"
      />
      <img src={banner} alt="Banner" className="w-full h-full object-cover" />

      {/* Centered Text */}
      <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-2 sm:px-4 pb-4 sm:pb-6 z-10">
        <h1 className="text-white font-oswald font-extrabold text-[32px] sm:text-[40px] md:text-[56px] lg:text-[72px] mb-4 leading-tight drop-shadow-md">
          {t("casualGamesbannermain")}
        </h1>

        <p className="text-white font-oswald font-medium text-[18px] sm:text-[24px] md:text-[30px] lg:text-[36px] mb-0 drop-shadow-sm">
          {t("casualGamesbannersubmain")}
        </p>

        <div className="mt-6">
          {/* <button
            onClick={handleRequestDemo}
            className="w-full min-w-[250px] flex items-center gap-6 justify-center bg-[#070b28] text-white py-5 px-6 rounded-xl hover:bg-[#222] transition-all border border-white/20"
          >
            <i className="fa fa-calendar-check fa-2x text-white"></i>
            <div className="text-left leading-tight">
              <p className="text-sm font-semibold">{t("reqfora")}</p>
              <p className="text-xl font-bold">{t("demo")}</p>
            </div>
          </button> */}
          <button
            onClick={handleRequestDemo}
            type="button"
            className="w-full flex items-center justify-center gap-3 bg-[#070b28] text-white py-4 px-6 rounded font-bold hover:bg-[#222] transition-all"
          >
            <i className="fa fa-calendar-check fa-lg text-white"></i>
            <span>
              {t("reqfora")} {t("demo")}
            </span>
          </button>
        </div>
      </div>

      {/* Request Demo Form Modal */}
      {showForm && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm">
          <div className="relative w-full h-full flex items-center justify-center px-4 font-gamerji ">
            <div className="relative w-full max-w-3xl bg-[rgb(7,11,40)] text-white rounded-xl p-8 overflow-auto max-h-[90vh]">

              {/* Close Button */}
              <button
                onClick={handleCloseForm}
                className="absolute top-4 right-4 text-white text-3xl hover:text-red-500 z-10"
              >
                &times;
              </button>

              <h2 className="text-2xl font-bold mb-6 text-center">Request a Demo</h2>

              <form className="grid grid-cols-1 sm:grid-cols-2 gap-4" onSubmit={handleSubmit}>
                {/* Name */}
                <div className="col-span-1">
                  <input
                    name="name"
                    type="text"
                    placeholder="Name*"
                    value={formData.name}
                    onChange={handleChange}
                    className={`p-3 rounded bg-white/10 outline-none w-full ${errors.name ? "border border-red-500" : ""
                      }`}
                  />
                  {errors.name && <p className="text-red-500 text-sm mt-1">{errors.name}</p>}
                </div>

                {/* Email */}
                <div className="col-span-1">
                  <input
                    name="email"
                    type="email"
                    placeholder="Email*"
                    value={formData.email}
                    onChange={handleChange}
                    className={`p-3 rounded bg-white/10 outline-none w-full ${errors.email ? "border border-red-500" : ""
                      }`}
                  />
                  {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
                </div>

                {/* Phone */}
                <div className="col-span-1">
                  <input
                    name="phone"
                    type="tel"
                    placeholder="Phone No*"
                    value={formData.phone}
                    onChange={handleChange}
                    className={`p-3 rounded bg-white/10 outline-none w-full ${errors.phone ? "border border-red-500" : ""
                      }`}
                  />
                  {errors.phone && <p className="text-red-500 text-sm mt-1">{errors.phone}</p>}
                </div>

                {/* Company */}
                <div className="col-span-1">
                  <input
                    name="company"
                    type="text"
                    placeholder="Company Name*"
                    value={formData.company}
                    onChange={handleChange}
                    className={`p-3 rounded bg-white/10 outline-none w-full ${errors.company ? "border border-red-500" : ""
                      }`}
                  />
                  {errors.company && <p className="text-red-500 text-sm mt-1">{errors.company}</p>}
                </div>

                {/* Multi-select dropdown */}
                <div className="relative col-span-1 sm:col-span-2">
                  <div
                    className={`flex items-center justify-between p-3 rounded bg-white/10 outline-none cursor-pointer ${errors.selectedOptions ? "border border-red-500" : ""
                      }`}
                    onClick={() => setShowDropdown(!showDropdown)}
                  >
                    <div className="flex-1">
                      {selectedOptions.length > 0 ? selectedOptions.join(", ") : "Interested In*"}
                    </div>
                    <button type="button" className="ml-2 text-white">
                      <svg
                        className={`w-4 h-4 transform transition-transform duration-200 ${showDropdown ? "rotate-180" : ""
                          }`}
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        viewBox="0 0 24 24"
                      >
                        <path d="M19 9l-7 7-7-7" />
                      </svg>
                    </button>
                  </div>

                  {/* Dropdown Options */}
                  {showDropdown && (
                    <div className="absolute z-10 mt-2 bg-[rgb(7,11,40)] border border-white/10 rounded shadow-lg w-full max-h-[150px] overflow-y-auto">
                      {options.map((option) => (
                        <label
                          key={option}
                          className="flex items-center px-4 py-2 text-white hover:bg-white/10 cursor-pointer"
                        >
                          <input
                            type="checkbox"
                            checked={selectedOptions.includes(option)}
                            onChange={() => {
                              toggleOption(option);
                              setErrors({ ...errors, selectedOptions: "" });
                            }}
                            className="mr-2 accent-white"
                          />
                          {option}
                        </label>
                      ))}
                    </div>
                  )}

                  {errors.selectedOptions && (
                    <p className="text-red-500 text-sm mt-1">{errors.selectedOptions}</p>
                  )}
                </div>

                {/* Requirement */}
                <div className="col-span-1 sm:col-span-2">
                  <textarea
                    name="requirement"
                    placeholder="Describe Your Requirement*"
                    value={formData.requirement}
                    onChange={handleChange}
                    rows={3}
                    className={`p-3 rounded bg-white/10 outline-none w-full ${errors.requirement ? "border border-red-500" : ""
                      }`}
                  />
                  {errors.requirement && (
                    <p className="text-red-500 text-sm mt-1">{errors.requirement}</p>
                  )}
                </div>

                {/* Captcha */}
                <div className="col-span-1 sm:col-span-2 flex justify-center">
                  <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey="6LdK8S4gAAAAAIcP1C6VUecXMZ0BWdeqLm775nn6"
                    onChange={(token) => setCaptchaToken(token)}
                    onExpired={() => {
                      setCaptchaToken(null);
                      recaptchaRef.current?.reset();
                    }}
                  />
                </div>

                {/* Submit */}
                <div className="col-span-1 sm:col-span-2">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className={`w-full bg-white text-[#070b28] py-3 rounded font-bold transition-all ${isSubmitting ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-200"
                      }`}
                  >
                    {isSubmitting ? "Submitting..." : "Submit"}
                  </button>
                </div>
              </form>

            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Banner;
